<template>
  <EditCampaignBudgetModal
    :value="value"
    :available-budget="availableBudget"
    :is-loading="isLoading"
    :credit="credit"
    :budget-allocation-limit="budgetAllocationLimit"
    @input="changeModalVisibility"
    @submit="changeBudget"
  />
</template>

<script>
import { AdCampaignFinance } from '@/api/api';
import campaignId from '@/mixins/advertisement/campaignId';
import EditCampaignBudgetModal from './EditCampaignBudgetModal';
import { mapActions } from 'vuex';
import { SEARCH_ADS_CAMPAIGN_HINTS_SET_BUDGET_HINT } from '@/store/types';

export default {
  name: 'EditCampaignBudgetModalWrapper',
  components: {
    EditCampaignBudgetModal,
  },
  mixins: [campaignId],
  props: {
    budgetAllocationLimit: {
      type: Number,
      required: true,
    },
    credit: {
      type: Number,
      required: true,
    },
    value: {
      type: Boolean,
      required: true,
    },
    availableBudget: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      isLoading: false,
    };
  },
  methods: {
    ...mapActions({
      setCampaignBudgetHint: SEARCH_ADS_CAMPAIGN_HINTS_SET_BUDGET_HINT,
    }),
    changeModalVisibility(val) {
      this.$emit('input', val);
    },
    emitChangeAndClose() {
      this.changeModalVisibility(false);
      this.$emit('changed');
    },
    changeBudget(newBudgetInfo) {
      this.isLoading = true;
      return this.addCredit(newBudgetInfo)
        .then(({ body: { message = '' } }) => {
          if (message) {
            this.$message.success(message);
          }
        })
        .then(() => {
          this.setCampaignBudgetHint(false);

          this.emitChangeAndClose();
        })
        .catch(({ body: { message } }) => {
          if (message) {
            this.$message.error(message);
          }
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    addCredit(newBudgetInfo) {
      return newBudgetInfo.creditType === 'credit'
        ? this.addCreditToCampaign(newBudgetInfo)
        : this.addGiftToCampaign(newBudgetInfo);
    },
    addCreditToCampaign(budgetInfo) {
      return AdCampaignFinance.addCreditToCampaign(
        {
          itemId: this.campaignId,
        },
        {
          budget: budgetInfo.credit,
        },
      );
    },
    addGiftToCampaign(budgetInfo) {
      return AdCampaignFinance.addGiftToCampaign(
        {
          itemId: this.campaignId,
        },
        {
          gift_budget_id: budgetInfo.gift,
        },
      );
    },
  },
};
</script>
